import { Radio, FormControl, FormHelperText, FormLabel } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { Controller, useFormContext } from "react-hook-form";
import { FnComponents, I18n, ParseHtml } from 'utilities/utilities';
import { IRadio } from './RadioProps';
import { I18NextNs, TypeComponent } from 'enum/enum';

export const RadioListItem = ((props: IRadio) => {
    const {
        label,
        id,
        name,
        disabled = false,
        required = false,
        style,
        options,
        IsShowMessageError = true,
        defaultValue = "",
        size = "small",
        row = true,
        IsNotShowLabel = false,
    } = props;

    const { control, register, setValue } = useFormContext();

	const GenerateId: string = FnComponents.GetId(TypeComponent.radio, id, name);

    return (
        <Controller 
			name={name} 
			control={control} 
			rules={{ required: required }} 
			shouldUnregister={true} 
			defaultValue={defaultValue}
            render={({
                field: { value, ref },
                fieldState: { invalid }
			}) => {
                let isValid = invalid && !disabled;
				let helperText = IsShowMessageError ? `${I18n.SetText("required", I18NextNs.validation)} ${label}` : "";
                return (
                    <FormControl required={required} error={invalid} ref={ref} >
                        {!IsNotShowLabel && label && <FormLabel component="legend" style={{color:'rgba(0, 0, 0, 0.6) !important'}}>{label}</FormLabel>}
                        <FormGroup row={row} {...register(`${name}`)}>
                            {
                                options.map((item, index) => {
                                    let label = item.label;
                                    // let sID = id + "_" + item.value;
									let sID = GenerateId + "_" + item.value;
                                    let sKey = name + index;
                                    let IsDisabled = disabled || (item.disabled ?? false);
                                    return (
									<FormControlLabel 
										key={sKey}
                                        control={
											<Radio
												id={sID}
												disabled={IsDisabled}
												checked={value == item.value} // === บัค
												value={item.value}
												onChange={(e) => {												
													setValue(name, e.target.value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
													if(props.onChange) props.onChange(e.target.value)
												}}
												size={size}
												style={style}
											/>
										}
                                        sx={props.sx}    
                                        label={ParseHtml(label)}
                                    />)
                                })
                            }
                        </FormGroup>
                        {IsShowMessageError && isValid && (
							<FormHelperText>{helperText}</FormHelperText>
						)}
                    </FormControl >
                )
            }}
        />
    );
});